/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useReducer, useEffect } from "react";
import { useLocalstorage } from "rooks";
import TemplateReducer from "./TemplateReducer";
import {
  SET_LOADING,
  INIT_SCRAPE_TEMPLATES,
  GET_SCRAPE_TEMPLATES,
  SET_ERROR,
  GET_SCRAPE_TEMPLATE_ID,
  GET_SCRAPE_TEMPLATE_RETAILER,
  SET_REFETCHING,
  GET_MORE_SCRAPE_TEMPLATES,
  SET_SCRAPE_TEMPLATES_SEARCH,
  SET_SCRAPE_TEMPLATES_FILTER,
} from "./../types";
import { COUNT_PER_PAGE } from "config";
import {
  getScrapeTemplatesApi,
  getTemplateById as getTemplateByIdApi,
  getTemplateByRetailer as getTemplateByRetailerApi,
} from "api";
const ScrapeTemplateContext = createContext();
export const useScrapeTemplateContext = () => useContext(ScrapeTemplateContext);
const STORAGE_KEY = "armitage-scrape-template-state";

export const ScrapeTemplateProvider = (props) => {
  const initialState = {
    query: "",
    templates: [],
    template: {},
    totalCount: 0,
    resultCount: 0,
    totalPages: 0,
    currentPage: 1,
    isLoading: false,
    isRefetching: false,
    creationDateFrom: "",
    creationDateTo: "",
    lastRunDateFrom: "",
    lastRunDateTo: "",
  };

  const [value, set] = useLocalstorage(STORAGE_KEY, initialState);

  const [state, dispatch] = useReducer(TemplateReducer, value);

  useEffect(() => {
    set(state);
    return () => {};
  }, [state]);

  const getTemplates = async () => {
    // dispatch({
    //   type: INIT_TEMPLATES,
    // });
    setTemplatesLoading();
    const res = await getScrapeTemplatesApi({
      page: 1,
      size: COUNT_PER_PAGE,
      search: state?.query,
      status: (state?.status || []).join(","),
      creation_time_from: state?.creationDateFrom,
      creation_time_to: state?.creationDateTo,
      last_run_time_from: state?.lastRunDateFrom,
      last_run_time_to: state?.lastRunDateTo,
    });
    dispatch({
      type: res.success ? GET_SCRAPE_TEMPLATES : SET_ERROR,
      payload: res.payload,
    });
  };
  const loadMore = async () => {
    setTemplatesRefetching();
    const res = await getScrapeTemplatesApi({
      page: state.currentPage + 1,
      size: COUNT_PER_PAGE,
      search: state?.query,
      status: (state?.status || []).join(","),
      creation_time_from: state?.creationDateFrom,
      creation_time_to: state?.creationDateTo,
      last_run_time_from: state?.lastRunDateFrom,
      last_run_time_to: state?.lastRunDateTo,
    });
    dispatch({
      type: res.success ? GET_MORE_SCRAPE_TEMPLATES : SET_ERROR,
      payload: res.payload,
    });
  };

  const refetchTemplates = async () => {
    const res = await getScrapeTemplatesApi();
    dispatch({
      type: res.success ? GET_SCRAPE_TEMPLATES : SET_ERROR,
      payload: res.payload,
    });
  };

  const getTemplateByRetailer = async (id) => {
    const res = await getTemplateByRetailerApi(id);
    dispatch({
      type: res.success ? GET_SCRAPE_TEMPLATE_RETAILER : SET_ERROR,
      payload: res.payload,
    });
  };

  const getTemplateById = async (id) => {
    setTemplatesLoading();
    const res = await getTemplateByIdApi(id);
    dispatch({
      type: res.success ? GET_SCRAPE_TEMPLATE_ID : SET_ERROR,
      payload: res.payload,
    });
  };

  const initScrapeTemplates = async () => {
    dispatch({
      type: INIT_SCRAPE_TEMPLATES,
    });
  };

  const setQuery = (query) => {
    dispatch({ type: SET_SCRAPE_TEMPLATES_SEARCH, payload: query });
  };
  // Set Loading
  const setTemplatesLoading = (params = true) =>
    dispatch({ type: SET_LOADING, payload: params });

  // Set Refetching
  const setTemplatesRefetching = (params = true) =>
    dispatch({ type: SET_REFETCHING, payload: params });

  const setFilter = (params) => {
    dispatch({ type: SET_SCRAPE_TEMPLATES_FILTER, payload: params });
  };
  const { children } = props;

  return (
    <ScrapeTemplateContext.Provider
      value={{
        ...state,
        initScrapeTemplates,
        setTemplatesLoading,
        getTemplates,
        getTemplateById,
        getTemplateByRetailer,
        refetchTemplates,
        loadMore,
        setTemplatesRefetching,
        setQuery,
        setFilter,
      }}
    >
      {children}
    </ScrapeTemplateContext.Provider>
  );
};
